export default __webpack_public_path__ + "static/media/instrumentation.d58f2a72.jpg";